// extracted by mini-css-extract-plugin
export var errorIcon = "_js-1";
export var nameLogo = "_js-0";